import React from 'react';
import PropTypes from 'prop-types';

import Button from '@redbubble/design-system/react/Button';
import Box from '@redbubble/design-system/react/Box';
import * as constants from '@redbubble/design-system/react/constants';

import FavoriteIcon, { SMALL, MEDIUM } from '../FavoriteIcon';

const Favorite = ({ favorited, onClick, size }) => {
  return (
    <Box>
      <Button
        elevation={constants.ELEVATION_MEDIUM}
        onClick={onClick}
        circle
        size={SMALL}
        iconAfter={<FavoriteIcon size={size} favorited={favorited} />}
      />
    </Box>
  );
};

Favorite.propTypes = {
  size: PropTypes.oneOf([SMALL, MEDIUM]),
  onClick: PropTypes.func.isRequired,
  favorited: PropTypes.bool.isRequired
};

Favorite.defaultProps = {
  size: SMALL
};

export default Favorite;
